import simplebar from 'simplebar';
import vars from '../helpers';
import {transchoice} from '../modules/transchoice';

let simpleBarMenuHome = null;
let isSliderReady = false;
let containerPage = null;
const transChildrenArr = ['%count% детей', '%count% ребенок', '%count% ребенка', '%count% детей'];

let device = 'desktop';

if (vars.isMobile()) {
	device = 'mobile';
}

function initSwiper(initialIndex = 21) {
	let initialSlide = initialIndex;

	// const swiperFamily = new Swiper('#js-swiper-family', {
	// 	effect: 'fade',
	// 	speed: 200,
	// 	loop: true,
	// 	centeredSlides: true,
	// 	initialSlide : initialSlide,
	// 	loopedSlides: 10,
	// 	allowTouchMove: false,
	// 	slidesPerView: 1,
	// 	fadeEffect: {
	// 		crossFade: true
	// 	},
	// 	breakpoints: {
	// 		1025: {
	// 			loopedSlides: 30,
	// 			speed: 1000,
	// 		}
	// 	},
	// });

	// const swiperBg = new Swiper('#js-swiper-bg', {
	// 	speed: 800,
	// 	loop: true,
	// 	centeredSlides: true,
	// 	initialSlide : initialSlide,
	// 	loopedSlides: 10,
	// 	allowTouchMove: false,
	// 	slidesPerView: 1,
	// 	effect: 'fade',
	// 	fadeEffect: {
	// 		crossFade: true
	// 	},
	// 	breakpoints: {
	// 		1025: {
	// 			loopedSlides: 30,
	// 			speed: 1000,
	// 		}
	// 	}
	// });

	let updateSlidesTimeout = null;
	let activeIndexOfSlide = null;

	const swiperNames = new Swiper('#js-swiper-names', {
		loop: true,
		centeredSlides: true,
		slidesPerView: 'auto',
		// loopedSlides: 10,
		initialSlide: initialSlide,
		allowTouchMove: true,
		speed: 1000,
		slideToClickedSlide: true,
		direction: 'vertical',
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// },
		breakpoints: {
			1025: {
				// loop: true,
				loopedSlides: 30,
				allowTouchMove: true,
				speed: 1000,
				slideToClickedSlide: true,
				freeMode: {
					enabled: true,
					sticky: false,
					momentum: false,
					momentumBounce: false,
				},
			}
		},
		mousewheel: {
			releaseOnEdges: false,
			eventsTarget: '.home',
			forceToAxis: true,
			thresholdDelta: 7,
			enabled: true,
			sensitivity: 0.25,
		},
		on: {
			init() {
				isSliderReady = true

				if (!vars.isMobile()) {
					updateClasses(this);
				}
			},
			slideChange() {
				if(isSliderReady) {
					if (!vars.isMobile()) {
						updateClasses(this);

						if (updateSlidesTimeout) {
							clearTimeout(updateSlidesTimeout);
						}

						activeIndexOfSlide = this.realIndex;
						updateSlidesTimeout = setTimeout(slideToSlide, 400);
					}
					else {
						if (updateSlidesTimeout) {
							clearTimeout(updateSlidesTimeout);
						}

						activeIndexOfSlide = this.realIndex;
						updateSlidesTimeout = setTimeout(updateActiveSlide, 400);
					}
				}
			},
		},
	});

	function slideToSlide() {
		// swiperFamily.slideToLoop(activeIndexOfSlide);
		// swiperBg.slideToLoop(activeIndexOfSlide);

		updateImage();
		updateContent();
	}

	function updateActiveSlide() {
		$('.home-slider__item').removeClass('is-eventTrue');
		$('.home-slider__item.swiper-slide-active').addClass('is-eventTrue');

		slideToSlide();
	}

	/* Transition for slider of background */
	let oldID = initialIndex;
	let $imageFront = containerPage.querySelector('.home-bg-slider__img--front');
	let $imageBack = containerPage.querySelector('.home-bg-slider__img--back');

	function updateImage() {
		let indexSlide = swiperNames.realIndex + 1;

		const urlWebp = `${data.baseDir}images/pages/articles/${indexSlide}/cover-${device}.webp`;
		const urlJpg = `${data.baseDir}images/pages/articles/${indexSlide}/cover-${device}.jpg`;

		if( $($imageFront).hasClass('is-active') ){
			transitionBackground($imageBack, $imageFront, {webp: urlWebp, jpg: urlJpg});
		} else {
			transitionBackground($imageFront, $imageBack, {webp: urlWebp, jpg: urlJpg});
		}

		oldID = indexSlide;
	}

	/* Transition for slider of content */
	let $linkName = containerPage.querySelector('.home-footer__name');
	let $linkBtn = containerPage.querySelector('.home-footer-link');
	let $circlesChildren = containerPage.querySelector('.home-footer-children__circles');
	let $numberChildren = containerPage.querySelector('.home-footer-children__number');

	function updateContent() {
		let indexSlide = swiperNames.realIndex + 1;

		let linkArticle = data.families[swiperNames.realIndex].link;
		let nameArticle = data.families[swiperNames.realIndex].name;
		let numberChildren = data.families[swiperNames.realIndex].children
		const numberChildrenText = transchoice(numberChildren, transChildrenArr);

		$($linkName).attr('href', linkArticle);
		$($linkBtn).attr('href', linkArticle);
		$($linkName).text(nameArticle)
		$($numberChildren).text(numberChildrenText)

		$($circlesChildren).html('');
		for(let i = 0; i < numberChildren; i++) {
			$($circlesChildren).append('<div class="home-footer__circle"></div>')
		}

		oldID = indexSlide;
	}
}

function preloadImage() {
	let images = [];

	for( let i =1; i <= data.families.length; i++) {
		images.push(`${data.baseDir}images/pages/articles/${i}/cover-${device}.jpg`);
	}

	jQuery.preloadImages = function()
	{
		jQuery("<img>").attr("src", images[21]);

		for(var i = 0; i < images.length; i++)
		{
			jQuery("<img>").attr("src", images[i]);
		}
	};

	$.preloadImages();
}

function initBackground(initialIndex = 21) {
	let indexSlide = initialIndex + 1;

	let $imageFront = containerPage.querySelector('.home-bg-slider__img--front');
	let $imageBack = containerPage.querySelector('.home-bg-slider__img--back');

	const urlWebp = `${data.baseDir}images/pages/articles/${indexSlide}/cover-${device}.webp`;
	const urlJpg = `${data.baseDir}images/pages/articles/${indexSlide}/cover-${device}.jpg`;

	transitionBackground($imageBack, $imageFront, {webp: urlWebp, jpg: urlJpg});
}

function transitionBackground(nextEl, prevEl, url) {
	$(nextEl).find('.js-webp').attr('srcset', '#');
	$(nextEl).find('.js-webp').attr('srcset', url.webp);

	$(nextEl).find('.js-jpg').attr('srcset', '#');
	$(nextEl).find('.js-jpg').attr('srcset', url.jpg);


	$(prevEl).removeClass('is-active');
	$(nextEl).addClass('is-active');
}

function initContent(initialIndex = 21) {
	let $linkName = containerPage.querySelector('.home-footer__name');
	let $linkBtn = containerPage.querySelector('.home-footer-link');
	let $circlesChildren = containerPage.querySelector('.home-footer-children__circles');
	let $numberChildren = containerPage.querySelector('.home-footer-children__number');

	let linkArticle = data.families[initialIndex].link;
	let nameArticle = data.families[initialIndex].name;
	let numberChildren = data.families[initialIndex].children;
	let numberChildrenText = transchoice(data.families[initialIndex].children, transChildrenArr);

	$($linkName).attr('href', linkArticle);
	$($linkBtn).attr('href', linkArticle);
	$($linkName).text(nameArticle)
	$($numberChildren).text(numberChildrenText)

	$($circlesChildren).html('');
	for(let i = 0; i < numberChildren; i++) {
		$($circlesChildren).append('<div class="home-footer__circle"></div>')
	}
}

function updateClasses({ $el, slides, activeIndex }) {
	/* Function is used to add style classes from the active slide */

	let repeatSlides = 10;

	let prevSlide = slides.eq(activeIndex).prev();
	let nextSlide = slides.eq(activeIndex).next();
	const $slide = $('.swiper-slide');

	for (let i = 0; i < repeatSlides; i++) {
		$slide.removeClass(`swiper-slide-prev-${i}`);

		const lastPrevSlide = prevSlide.prev();
		$(lastPrevSlide).addClass(`swiper-slide-prev-${i}`);
		prevSlide = lastPrevSlide;

		$slide.removeClass(`swiper-slide-next-${i}`);

		const lastNextSlide = nextSlide.next();
		$(lastNextSlide).addClass(`swiper-slide-next-${i}`);
		nextSlide = lastNextSlide;
	}
}

function initMenuScroll() {
	if(!simpleBarMenuHome) {
		simpleBarMenuHome = new simplebar(document.getElementById('menu-scroll'));
	}
}

function init(container) {
	isSliderReady = false;
	containerPage = container;

	if( $(window).width() > 768 ) {
		setTimeout(function () {
			initMenuScroll();
		}, 300);
	}

	let eventResize = function () {
		if( $(window).width() > 768 ) {
			initMenuScroll();
		} else {
			destroySimpleBarMenu();
		}
	}

	// preloadImage();

	window.addEventListener('resize', eventResize, true);
}

function destroySimpleBarMenu() {
	if(simpleBarMenuHome) {
		simpleBarMenuHome.unMount();
		simpleBarMenuHome = null;
	}
}

function destroy() {
	destroySimpleBarMenu();
}

export default {
	init,
	destroy,
	initSwiper,
	initBackground,
	initContent
};
